/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  AddressDto,
  CreateAddressRequest,
  UpdateAddressRequest
} from '../model';

import { apiRequest } from '../../client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Create an address.
 * @summary Create Address.
 */
export const createAddress = (
    createAddressRequest: CreateAddressRequest,
 options?: SecondParameter<typeof apiRequest<AddressDto>>,) => {
      return apiRequest<AddressDto>(
      {url: `/addresses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAddressRequest
    },
      options);
    }
  /**
 * Update an address.
 * @summary Update Address.
 */
export const updateAddress = (
    updateAddressRequest: UpdateAddressRequest,
 options?: SecondParameter<typeof apiRequest<AddressDto>>,) => {
      return apiRequest<AddressDto>(
      {url: `/addresses`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAddressRequest
    },
      options);
    }
  /**
 * Get an address.
 * @summary Get Address.
 */
export const getAddress = (
    addressID: string,
 options?: SecondParameter<typeof apiRequest<AddressDto>>,) => {
      return apiRequest<AddressDto>(
      {url: `/addresses/${addressID}`, method: 'GET'
    },
      options);
    }
  /**
 * Get all mapped addresses for an address.
 * @summary Get Address Mappings.
 */
export const getAddressMappings = (
    addressID: string,
 options?: SecondParameter<typeof apiRequest<AddressDto[]>>,) => {
      return apiRequest<AddressDto[]>(
      {url: `/addresses/${addressID}/mappings`, method: 'GET'
    },
      options);
    }
  export type CreateAddressResult = NonNullable<Awaited<ReturnType<typeof createAddress>>>
export type UpdateAddressResult = NonNullable<Awaited<ReturnType<typeof updateAddress>>>
export type GetAddressResult = NonNullable<Awaited<ReturnType<typeof getAddress>>>
export type GetAddressMappingsResult = NonNullable<Awaited<ReturnType<typeof getAddressMappings>>>
